import { Product } from "@domain/product/product";
import { AlarmDeviceConfiguration } from "@domain/project/configurations/alarm-device-configuration";

export class OriginalAlarmDeviceConfiguration {
  productConfiguration: AlarmDeviceConfiguration;
  alarmDevices: Product[];
  attachments: { product: Product; quantity: number }[];

  constructor(
    productConfiguration: AlarmDeviceConfiguration,
    alarmDevices: Product[],
    attachments: { product: Product; quantity: number }[],
  ) {
    this.productConfiguration = productConfiguration;
    this.alarmDevices = alarmDevices;
    this.attachments = attachments;
  }
}
